var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimRowApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 4h12c.5522847 0 1 .44771525 1 1v14c0 .5522847-.4477153 1-1 1h-12c-.55228475 0-1-.4477153-1-1v-14c0-.55228475.44771525-1 1-1zm1 3v1h5v-1zm0 5v1h10v-1zm0 2v1h9v-1zm0 2v1h5v-1z",
    fill: "#b2f2bb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    fill: "#69db7c",
    r: 8,
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.9492188 8.90626703c-.2005219.19582296-.4335925.29373297-.6992188.29373297s-.4986969-.09791001-.6992188-.29373297l-1.4023437-1.36566757c-.0989588-.09918306-.1484375-.21362333-.1484375-.34332426 0-.12970092.0507807-.24414119.1523438-.34332425.0989588-.0966399.214843-.14495912.3476562-.14495912s.2499995.04831922.3515625.14495912l1.3984375 1.36948229 3.1484375-3.07847411c.101563-.0966399.2187493-.14495913.3515625-.14495913s.2499995.04831923.3515625.14495913c.0989588.09918306.1484375.21362333.1484375.34332425s-.0494787.24414119-.1484375.34332425z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimRowApproved);
export default __webpack_public_path__ + "static/media/claim-row-approved.9e794d3487a8f7f253c8fde5ab0a8174.svg";
export { ForwardRef as ReactComponent };